import { Component, ViewChild, AfterViewInit, OnInit, ElementRef, ChangeDetectorRef, NgZone } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { HttpClient } from '@angular/common/http';
import { DelegationofauthorityService } from '../../../services/delegationofauthority/delegationofauthority.service';
import { Costcenterlist } from '../../../interface/delegationofauthority/costcenterlist';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { SharedServices } from '../../../shared/services/shared.services';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DisplaypageComponent } from '../displaypage/displaypage.component';
import { Overlay } from '@angular/cdk/overlay';

@Component({
  selector: 'app-bycostcenter',
  imports: [CommonModule, FormsModule, MatPaginatorModule, MatTableModule, MatProgressSpinner],
  templateUrl: './bycostcenter.component.html',
  styleUrls: ['./bycostcenter.component.css']
})
export class BycostcenterComponent implements AfterViewInit, OnInit {
  employees: Costcenterlist[] = [];
  filteredEmployees = new MatTableDataSource<Costcenterlist>([]);
  isLoading: boolean = false;
  showFields: boolean = false;
  recordsPerPage: number = 10;
  displayedColumns: string[] = ['sno', 'employeeName', 'jobTitle', 'deptName', 'divisionName', 'sectionName', 'costCenter'];
  error: string | null = null;
  selectedCostCenterOp: string = '';
  selectedCostCenterValue: string = '';
  selectedOrderBy: string = '';

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild('costCenterOp') costCenterOp!: ElementRef<HTMLSelectElement>;
  @ViewChild('costCenterValue') costCenterValue!: ElementRef<HTMLInputElement>;
  @ViewChild('orderBy') orderBy!: ElementRef<HTMLSelectElement>;

  constructor(
    private http: HttpClient,
    private doaService: DelegationofauthorityService,
    private sharedService: SharedServices,
    private ngZone: NgZone,
    private dialog: MatDialog,
    private overlay: Overlay
  ) {}

  ngAfterViewInit(): void {
    this.filteredEmployees.paginator = this.paginator;
  }

  ngOnInit(): void {}

  submitForm(): void {
    const costCenterOp = this.costCenterOp.nativeElement.value;
    const costCenterValue = this.costCenterValue.nativeElement.value;
    const orderBy = this.orderBy.nativeElement.value;
    this.selectedCostCenterOp = costCenterOp;
    this.selectedCostCenterValue = costCenterValue;
    this.selectedOrderBy = orderBy;

    if (!costCenterValue) {
      this.sharedService.openModal('Message', 'Provide Cost Center value');
      return;
    }
    this.ngZone.run(() => {
      this.isLoading = true;
      this.showFields = true;
    });
    this.doaService.getEmployeesByCostCenter(costCenterOp, costCenterValue, orderBy).subscribe(
      (data: Costcenterlist[]) => {
        this.ngZone.run(() => {
          this.isLoading = false;
          if (data && data.length > 0) {
            data.forEach((item, index) => item.sno = index + 1);
            this.employees = data;
            this.filteredEmployees.data = data;
            this.filteredEmployees.paginator = this.paginator;
            this.error = null;
          } else {
            this.filteredEmployees.data = [];
            this.showFields = false;
          }
        });
      },
      (error) => {
        this.ngZone.run(() => {
          this.error = 'Error fetching data';
          this.isLoading = false;
          this.filteredEmployees.data = [];
          this.showFields = false;
        });
      }
    );
  }

  onPageChange(event: PageEvent): void {
    this.recordsPerPage = event.pageSize;
    this.filteredEmployees.paginator = this.paginator;
  }

  navigateToDisplayPage(employeeNo: string): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '99%';
    dialogConfig.height = '99%';
    dialogConfig.data = { employeeNo };

    const dialogRef = this.dialog.open(DisplaypageComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  downloadExcel(): void {
    const costCenterOp = this.costCenterOp.nativeElement.value;
    const costCenterValue = this.costCenterValue.nativeElement.value;
    const orderBy = this.orderBy.nativeElement.value;

    if (!costCenterValue) {
      this.sharedService.openModal('Message', 'Provide Cost Center value');
      return;
    }

    this.doaService.getEmployeeMasterWorksheet(costCenterOp, costCenterValue, orderBy).subscribe(
      response => {
        const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `CostCenterData_${new Date().toISOString().slice(0, 19).replace(/:/g, '-')}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
      },
      error => {
        console.error('Error downloading the Excel file', error);
      }
    );
  }
}